import React, { useState } from 'react';
import '../css/Contact.css';
import api from '../utils/axiosConfig';

function Contact() {
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const [captcha, setCaptcha] = useState({
    num1: Math.floor(Math.random() * 10),
    num2: Math.floor(Math.random() * 10),
    answer: ''
  });

  const [status, setStatus] = useState('');
  const [captchaError, setCaptchaError] = useState('');

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const handleCaptchaChange = (e) => {
    setCaptcha({
      ...captcha,
      answer: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const correctAnswer = captcha.num1 + captcha.num2;

    if (parseInt(captcha.answer) !== correctAnswer) {
      setCaptchaError('Bitte lösen Sie die Rechenaufgabe korrekt.');
      return;
    }

  setCaptchaError('');

    try {
      await api.post('/api/contact', form);
      setStatus('Nachricht erfolgreich gesendet!');
      setForm({ name: '', email: '', phone: '', message: '' });

      // reset captcha after success
      setCaptcha({
        num1: Math.floor(Math.random() * 10),
        num2: Math.floor(Math.random() * 10),
        answer: ''
      });

    } catch (error) {
      setStatus('Fehler beim Senden der Nachricht.');
    }
  };

  return (
    <div className="contact-container">
      <div className="contact-content">
        <h1 className="contact-title">Kontakt</h1>

        <section className="contact-section">
          Ansprechpartner: INCLASS-Team<br />
          E-Mail: <a href="inclass-app@dipf.de">inclass-app@dipf.de</a><br />
          Telefonnummer: +49 (0)69-24708-545<br /><br />
          <b>DIPF | Leibniz-Institut für Bildungsforschung und Bildungsinformation</b><br />
            Rostocker Straße 6<br />
            60323 Frankfurt am Main<br />
            Deutschland
        </section>

        <section className="contact-section">
          <h2>Schreiben Sie uns</h2>
          <p>Füllen Sie das Formular aus, wir melden uns so schnell wie möglich.</p>
        </section>

        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Name *</label>
            <input
              type="text"
              name="name"
              value={form.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>E-Mail-Adresse *</label>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Telefonnummer *</label>
            <input
              type="tel"
              name="phone"
              value={form.phone}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Nachricht *</label>
            <textarea
              name="message"
              rows="5"
              value={form.message}
              onChange={handleChange}
              required
            />
          </div>

          <div className="captcha-container">
            <label>
              Sicherheitsfrage: {captcha.num1} + {captcha.num2} = ?
            </label>

            <input
              type="number"
              value={captcha.answer}
              onChange={handleCaptchaChange}
              required
            />

            {captchaError && <p className="captcha-error">{captchaError}</p>}
          </div>

          <button type="submit" className="submit-btn">
            Senden
          </button>

          {status && <p className="form-status">{status}</p>}
        </form>
      </div>
    </div>
  );
}

export default Contact;